<template lang="pug">
  component.wt-label(
    :is="isLabelElement ? 'label' : 'span'"
    :for="labelFor"
    :class="{'label': isLabelElement }"
  )
    div
      span.has-text-danger.mr-1(v-if="required")  *
      span {{ text }}
      BTooltip(
        v-if="!!tooltipText.length"
        :position="position"
        :active="!!tooltipText.length"
        :label="tooltipText"
        animated
        size="is-small"
        type="is-light"
        :multilined="true"
      )
        BIcon.ml-1(size="is-small" icon="help-circle-outline")
    .sub-label.has-text-grey(v-if="subLabel") {{ subLabel }}
</template>

<script>
export default {
  name: "WtLabel",

  props: {
    /**
     * label for the input
     */
    text: {
      type: String,
      required: true
    },
    /**
     * text below main label
     */
    subLabel: {
      type: String,
      default: ""
    },

    position: {
      type: String,
      default: "is-top"
    },

    tooltipText: {
      type: String,
      default: ""
    },

    labelFor: {
      type: String,
      default: ""
    },

    required: {
      type: Boolean,
      default: false
    },

    isLabelElement: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped></style>
